<template>
<div class="container">
  <div class="col-12 userpage-services text-center" v-if="services.length==0">
    <p>услуги не найдены</p>
  </div>
  <div class="row userpage-services d-flex justify-content-center" v-if="services.length>0">
    <div class="col-12 col-md-6 userpage-service-container" v-for="(service,service_index) in services" :key="service.last_id">
      <div class="userpage-service">
        <v-lazy-image class="userpage-service-img"  :src="image_url+service.image"/>
         <div class="userpage-service-text">
          <h4 class="userpage-service-title">{{ service.name}}</h4>
          <p><router-link class="btn userpage-service-btn" tag="a"
              :to="{name: 'user_page_service', params: {user_id:user.last_id,service_id:service.last_id  }}">Заказать</router-link></p>

        </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from "vue";
import VLazyImage from "v-lazy-image/v2";

export default {
  name: "ServicesListUserPage.vue",
  props: ["services","user"],
  components: {
    VLazyImage
  },
  data(){
    return {
      "image_url":null,
    }
  },
  mounted(){
    var app=this;
    app.image_url = Vue.config.IMAGE_URL;
  }
}
</script>

<style scoped>

</style>